import { ArrowRight } from 'lucide-react';
import { trackEvent, EVENTS } from '../utils/analytics';
import { Link } from 'react-router-dom';
import { appEntryDestination } from '../../client/authContinuation';

const content = {
  solo_founder: {
    headline: 'Build the right product, without hiring a PM.',
    description: 'Pabs runs the product management function. Your existing tools keep running the delivery.',
    primaryCTA: 'Get started free',
    showSecondary: false,
  },
  pm: {
    headline: 'The strategic OS for product teams',
    description:
      'Standardize your strategic deliverables with the Decision Engine. Traceable, defensible, and high-fidelity.',
    primaryCTA: 'Get Started',
    secondaryCTA: 'Contact for Team Access',
    showSecondary: true,
  },
  consultant: {
    headline: 'Boost your strategic deliverables',
    description:
      'Deliver high-quality, client-ready strategy documents that stand up to scrutiny. Elevate your consulting with AI-powered rigor.',
    primaryCTA: 'Get Started',
    secondaryCTA: 'Contact for Professional Access',
    showSecondary: true,
  },
  startup: {
    headline: 'Validate faster. Build with certainty.',
    description:
      'Transform vague ideas into structured action plans in minutes. Reduce misbuild risk by 40%.',
    primaryCTA: 'Get started free',
    showSecondary: false,
  },
};

export default function CTASection({ audience = 'solo_founder' }) {
  const current = content[audience] || content.solo_founder;

  const handlePrimary = () => {
    trackEvent(EVENTS.CTA_CLICKED, { cta_id: 'final_cta_start', audience, section: 'conversion' });
    window.location.href = appEntryDestination();
  };

  const handleSecondary = () => {
    trackEvent(EVENTS.CTA_CLICKED, { cta_id: 'final_cta_contact', audience, section: 'conversion' });
    window.location.href = '/register';
  };

  return (
    <section className="py-24 bg-brand-900 text-brand-50 border-t border-brand-50/10 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_120%,rgba(60,20,120,0.3),transparent_70%)]"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2
            className="text-4xl md:text-6xl font-bold mb-8 tracking-tighter"
            dangerouslySetInnerHTML={{ __html: current.headline }}
          />

          <p className="text-xl text-brand-400 mb-12 max-w-2xl mx-auto font-light">
            {current.description}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
            <button
              onClick={handlePrimary}
              className="bg-brand-50 text-brand-900 hover:bg-brand-200 text-lg px-10 py-5 rounded-full font-semibold flex items-center gap-2 transition-colors"
            >
              {current.primaryCTA}
              <ArrowRight className="ml-2 h-5 w-5" />
            </button>
            <Link to="/docs/install-pabs" className="inline-flex items-center rounded-full border border-brand-400 px-8 py-5 font-semibold text-brand-50 hover:border-brand-50">Install Pabs</Link>

            {current.showSecondary && (
              <button
                onClick={handleSecondary}
                className="text-brand-400 hover:text-brand-50 transition-colors font-medium px-8 py-5"
              >
                {current.secondaryCTA}
              </button>
            )}
          </div>

          <div className="flex flex-wrap gap-6 justify-center">
            <div>
              <div className="text-sm font-bold text-brand-300 uppercase tracking-widest mb-2">
                Works with your tools
              </div>
              <div className="text-brand-500 text-xs">Codex, Claude, Cursor &amp; more</div>
            </div>
            <div>
              <div className="text-sm font-bold text-brand-300 uppercase tracking-widest mb-2">
                No docs required
              </div>
              <div className="text-brand-500 text-xs">Your strategy stays in Pabs; your client uses it live</div>
            </div>
            <div>
              <div className="text-sm font-bold text-brand-300 uppercase tracking-widest mb-2">
                Under 3 minutes
              </div>
              <div className="text-brand-500 text-xs">From vague idea to clear next decision</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
